// Image protection — mirrors the WooCommerce plugin behaviour.
//
//  1. Block the right-click context menu over the preview/widget image areas
//     (so the generated portrait can't be saved via "Save image as…").
//  2. Block F12 / DevTools keyboard shortcuts and View-Source.
//
// Opt-in: only the right-click guard is always installed (scoped to the widget
// image areas). The F12/DevTools guard is gated behind `data-disable-f12="true"`
// on #bf-widget-root and installed once via installProtection().
//
// Note: these are deterrents, not real security — anyone determined can still
// reach the image. We match the WooCommerce site's UX exactly.

let installed = false;

/**
 * Install image protection. Call once on boot.
 * @param disableF12 - when true, also block F12 / DevTools / View-Source keys
 *                     (read from `data-disable-f12="true"` on #bf-widget-root).
 */
export function installProtection(disableF12: boolean): void {
  if (installed || typeof document === 'undefined') return;
  installed = true;

  // 1. Disable right-click context menu on preview images.
  document.addEventListener('contextmenu', function (e) {
    const target = e.target as HTMLElement | null;
    if (
      target &&
      target.closest('.bf-preview-img, .bf-image-container, #bf-preview-root, #bf-widget-root')
    ) {
      e.preventDefault();
      return false;
    }
  });

  // 2. Disable F12 / DevTools shortcuts (opt-in).
  if (disableF12) {
    document.addEventListener('keydown', function (e) {
      if (e.key === 'F12' || e.keyCode === 123) {
        e.preventDefault();
        return false;
      }
      if (
        (e.ctrlKey || e.metaKey) &&
        e.shiftKey &&
        ['i', 'I', 'j', 'J', 'c', 'C'].indexOf(e.key) !== -1
      ) {
        e.preventDefault();
        return false;
      }
      if ((e.ctrlKey || e.metaKey) && (e.key === 'u' || e.key === 'U')) {
        e.preventDefault();
        return false;
      }
    });
  }
}
